import type { LogInRequest, LoginResult, RefreshTokensRequest } from 'api/models/mainservice';

import { apiClient } from './support/unprotectedBaseApiClients';

export default {
  logIn: (params: LogInRequest) => {
    return apiClient.post<LoginResult>('/public/auth/LogIn', params);
  },
  refreshTokens: (params: RefreshTokensRequest) => {
    return apiClient.post<LoginResult>('/public/auth/RefreshTokens', params);
  }
};
